import * as React from 'react';
import autobind from 'autobind-decorator';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import { resolve } from 'inversify-react';
import * as uuid from 'uuid';

import { ControllerProps } from 'src/router';
import { ErrataListView } from './errata-list.view';
import { FormatService } from 'src/core/services/format.service';
import { IdentityService } from 'src/core/services/identity.service';
import { DataLocalService } from 'src/core/services/data-local.service';

interface ErrataListControllerProps extends ComponentViewProps<ErrataItem[]> {
	mode: ControlMode;
	identityService: IdentityService;
	readOnly?: boolean;
}

@observer
export class ErrataListController extends React.Component<ErrataListControllerProps, any> {
    @observable
	dataSet: DataLocalService<ErrataItem>;
	constructor(props) {
        super(props);
	}

    @autobind
    deleteErrata(errata: ErrataItem) {
        this.dataSet.delete([errata]);
    }

	@autobind
	addErrata() {
		return this.dataSet
			.create(() => ({
				id: uuid.v4(),
				title: null,
				visibility: { client: [], agent: [], supplier: [] },
				creationDate: new Date(),
				userName: this.props.identityService.username,
				msg: '',
                html: '',
				bookingStartDate: new Date(),
				bookingEndDate: new Date(),
				serviceEndDate: new Date(),
				serviceStartDate: new Date()
			}))
			.then((res) => {
				return res;
			});
	}

	componentWillReceiveProps(nextProps: Readonly<ErrataListControllerProps>, nextContext: any) {
		this.dataSet = new DataLocalService(nextProps.model);
	}

	componentDidMount() {
		this.componentWillReceiveProps(this.props, null);
	}
	
	render() {
		if (this.dataSet == null) {
			return null;
		}

		return (
			<ErrataListView
				addErrata={this.addErrata}
				deleteErrata={this.deleteErrata}
				identityService={this.props.identityService}
				setBusy={this.props.setBusy}
				model={this.dataSet.items}
				parentMode={this.props.mode}
				readOnly={this.props.readOnly}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/general/erratas/list/errata-list.controller.tsx